"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _baseInfoCopy = _interopRequireDefault(require("./components/baseInfoCopy"));
var _rankingCopy = _interopRequireDefault(require("./components/rankingCopy"));
var _gridMenuCopy = _interopRequireDefault(require("./components/gridMenuCopy"));
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'Dashboard',
  components: {
    baseInfo: _baseInfoCopy.default,
    gridMenu: _gridMenuCopy.default,
    ranking: _rankingCopy.default
  },
  data: function data() {
    return {
      dialogVisible: false,
      merData: {},
      platformData: {},
      platformProductData: {}
    };
  },
  methods: {
    checkPermi: _permission.checkPermi
  }
};